import { lineString, nearestPointOnLine, point } from "@turf/turf";
import { LatLng } from "leaflet";

interface GeometryLine {
  geometry: GeometryPoint[];
}
interface GeometryPoint {
  lat: number;
  lng: number;
}

export const snapToLine = (asset: GeometryLine, e: GeometryPoint) => {
  // We flip the latlngs around so that they are handled appropriately by the turf library
  const points = asset.geometry.map((a) => [a.lng, a.lat]);

  if (points.length < 2) {
    return undefined;
  }

  const line = lineString(points);
  // We flip the latlngs around so that they are handled appropriately by the turf library
  const newPoint = point([e.lng, e.lat]);
  const snapped = nearestPointOnLine(line, newPoint);

  // We flip the latlngs back around so that they are handled appropriately by leaflet
  return new LatLng(snapped.geometry.coordinates[1], snapped.geometry.coordinates[0]);
};
